import { DashboardRoutes } from "@/router";
import { useAppDispatch, useAppSelector, useAppTranslation } from "@/utils";
import { ClockCircleOutlined } from "@payping/icons";
import { TokenDetailViewModel, getClientTokenList } from "@payping/redux/actions";
import { moment } from "@payping/utils/dateUtils";
import { Card, Flex, Skeleton, Typography, useMessagedAsync } from "@payping/web-components";
import { Link } from "react-router-dom";

interface TokenProps {
  tokenModel: { expireDate: Required<TokenDetailViewModel["expireDate"]> } & Omit<TokenDetailViewModel, "expireDate">;
}
const Token = ({ tokenModel }: TokenProps) => {
  const { t } = useAppTranslation();

  const twoWeeksLater = moment().add(2, "weeks");
  const now = moment().add(-1, "milliseconds");
  const tokenExpire = moment(tokenModel.expireDate);

  // two weeks remain to expire token
  if (tokenExpire.isBefore(twoWeeksLater) && tokenExpire.isAfter(now)) {
    return (
      <Card.Ant>
        <Flex align="center" justify="space-between">
          <Typography.Text>{t("overview.notifications.token.name", { name: tokenModel.clientName })}</Typography.Text>
          <Flex align="center" gap="4px">
            <ClockCircleOutlined className="color--" width={"16px"} />
            <Typography.Text>{t("overview.notifications.token.expire")}</Typography.Text>
          </Flex>
          <Link to={DashboardRoutes.connections.developers.root.url}>
            {t("overview.notifications.token.actions.edit")}
          </Link>
        </Flex>
      </Card.Ant>
    );
  }
  return null;
};

const Notifications = () => {
  const dispatch = useAppDispatch();

  const tokenList = useAppSelector((state) => state?.client?.token?.list);

  const { loading } = useMessagedAsync(() => dispatch(getClientTokenList()), [dispatch], { success: false });

  if (loading) {
    return <Skeleton active={loading} paragraph />;
  }
  if (!tokenList.length) return null;

  return (
    <Flex className="tw-w-full" vertical gap="8px" justify="center">
      {tokenList
        .filter((i) => !!i.expireDate)
        .map((i) => (
          <Token key={i.clientId} tokenModel={i as TokenProps["tokenModel"]} />
        ))}
    </Flex>
  );
};
export default Notifications;
